module.exports = __webpack_public_path__ + "img/bbc.ad962d2d.svg";